import React from 'react'
import { observer } from 'mobx-react'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const ParametersEdit = ({ store, updateField, ...rest }) => {
  const _ParametersEditForm = observer(({ record, updateFormField, errors }) => {
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput
            label={store.__('parameter title')}
            attr={'parameter_title'}
            record={record}
            onChange={updateFormField}
            errors={errors} />
          <TextInput
            label={store.__('parameter number')}
            attr={'parameter_number'}
            type='number'
            record={record}
            onChange={updateFormField}
            errors={errors} />
          <SelectInput
            label={store.__('type')}
            attr={'type'}
            record={record}
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'FieldTypes'}
            labelattr='text'
            errors={errors} />
          { ['select', 'multiselect'].includes(record.get('type')) &&
            (<SelectInput
              label={store.__('options attribute')}
              attr={'options_attr'}
              record={record}
              onChange={updateFormField}
              optionsrecord={store.options}
              optionsattr={'enumEntities'}
              labelattr='text'
              errors={errors} />
            )
          }
        </div>
      </div>
    )
  })

  return (
    <EmbededEntityInput
      store={store}
      helper='reports/parameters'
      label={store.__('parameters')}
      attr={'parameters'}
      edit_title={store.__('edit parameters')}
      add_title={store.__('add parameters')}
      fields={[
        (attr, row) => (
          <TextField attr={attr} val={row[attr]} />
        ),
        (attr, row) => (
          <TextField attr={attr} val={'%' + row[attr]} />
        ),
        (attr, row) => (
          <OptionsField
            attr={attr} val={row[attr]}
            options={store.options.get('FieldTypes')}
            labelattr='text' />
        ),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('enumEntities')}
            labelattr='text' />
        )
      ]}
      rowId={(row) => (row.id)}
      EditForm={_ParametersEditForm} {...rest}
    />
  )
}

// export default
export default observer(ParametersEdit)
